var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTelegram(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7 14C10.8669 14 14 10.8669 14 7C14 3.13308 10.8669 0 7 0C3.13308 0 0 3.13308 0 7C0 10.8669 3.13308 14 7 14ZM3.20308 6.84833L9.95225 4.24608C10.2655 4.13292 10.5391 4.3225 10.4376 4.79617L10.4382 4.79558L9.289 10.2095C9.20383 10.5933 8.97575 10.6867 8.65667 10.5058L6.90667 9.21608L6.06258 10.0293C5.96925 10.1226 5.8905 10.2013 5.70967 10.2013L5.83392 8.42042L9.07725 5.49033C9.21842 5.36608 9.04575 5.29608 8.85967 5.41975L4.85158 7.94325L3.12375 7.40425C2.74867 7.28525 2.7405 7.02917 3.20308 6.84833Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTelegram);
export default __webpack_public_path__ + "static/media/Telegram.0ec1ff3605f270adb426d11892e28042.svg";
export { ForwardRef as ReactComponent };